module.exports = __webpack_public_path__ + "img/services_header.99ba5c2c.png";